import React, { useEffect, useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import { EditorState } from "draft-js";
import { useDispatch } from "react-redux";
import { sanitize } from "dompurify";
import TextInputWithMentioned from "../../../components/textInputWithMentioned";
import Button from "../../../components/button";
import userIcon from "../../../assets/images/user_icone.png";
import Tags from "../../../components/tags";
import { replyObjection, solveObjection, getAdminsUsers } from "../api";
import { mapObjectionCommentToData } from "../mapToData";
import { setMessage } from "../../shared/notification/slice";
import trackAnalytics from "../../../trackAnalytics";

export const Objection = styled.div`
    background: #ffffff;
    border: 1px solid #e5e7eb80;
    border-radius: 4px;
    padding: 32px 24px;
    margin-left: 15px;
    width: 70%;
`;
export const ObjectionDetails = styled.div``;
export const Header = styled.div`
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #e5e7eb;
    justify-content: space-between;
    flex-wrap: wrap;
`;
export const CreatorDetails = styled.div`
    display: flex;
    flex-direction: row;
`;
export const CreatorIcon = styled.div`
    img {
        width: 44px;
        height: 44px;
    }
`;
export const CreatorInfo = styled.div`
    margin: 0 16px;

    .name {
        color: #006bb4;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
    }
    .email {
        color: #6b7280;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        flex-direction: row;
        .tags {
            margin: 0 5px;
        }
    }
`;
export const CreatedDate = styled.div`
    .label {
        color: #6b7280;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
    }
    .createdAt {
        color: #111827;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }
`;
const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
`;
const Item = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 32px;
    flex-wrap: wrap;

    p {
        color: #111827;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-transform: capitalize;
    }
`;
const LabelStyle = styled.div`
    color: #6b7280;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-transform: capitalize;
    margin-right: 1rem;
`;
export const NoReplies = styled.div`
    display: flex;
    font-size: 20px;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    text-transform: capitalize;
    padding: 24px;
`;
export const RepliesContainer = styled.div`
    background: #fbfbfb;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 24px;
    margin: 12px 0;
`;
export const ObjectionReplies = styled.div`
    ${RepliesContainer} {
        margin: 0 0 12px 0;
    }
    ${Item} {
        margin-bottom: 0;
    }
    ${TextInputWithMentioned} {
        width: 80%;
    }
`;
export const RepliesHeader = styled.div`
    background: #fbfbfb;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const Title = styled.div`
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    color: #6b7280;
`;
export const Count = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #285fa1;
`;
export const RepliesContent = styled.div`
    max-height: 567px;
    overflow-y: auto;
    margin-top: 24px;
    padding-right: 5px;
`;
export const TextInputWithMentionedStyled = styled.div`
    width: 80%;
`;
export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;
export const ObjectionSectionInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    ${Item} {
        flex: 1;
    }
`;
export default function ObjectionsView({
    activeObjectionId,
    objection,
    submitObjectionSuccessfully,
}) {
    const [mentionedUsers, setMentionedUsers] = useState();
    const [userInfo, setUserInfo] = useState({ userName: "", userEmail: "" });
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [replyData, setReplyData] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        getMentionedUsers();
        setUserInfo({
            userName: localStorage.getItem("firstName") + localStorage.getItem("lastName"),
            userEmail: localStorage.getItem("email"),
        });
    }, []);

    const getMentionedUsers = async () => {
        const data = await getAdminsUsers();
        setMentionedUsers(_.values(data?.entities["adminUsers"]));
    };

    const handleSolve = () => {
        trackAnalytics("Solve object submission");

        solveObjection(activeObjectionId)
            .then(async (res) => {
                dispatch(
                    setMessage({
                        content: `solved successfully `,
                        isError: false,
                    })
                );
                window.location.reload(true);
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't solve your reply  `,
                        isError: true,
                    })
                );
            });
    };
    const handleReply = () => {
        trackAnalytics("Reply to object submission", {
            NoOfRepliesPerObject: objection?.objectionReplies?.length,
        });

        replyObjection(mapObjectionCommentToData(activeObjectionId, handleDataBeforeSubmit()))
            .then(async (res) => {
                dispatch(
                    setMessage({
                        content: `reply submitted successfully `,
                        isError: false,
                    })
                );
                setEditorState(EditorState.createEmpty());
                setReplyData("");
                submitObjectionSuccessfully(true);
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't submit your reply  `,
                        isError: true,
                    })
                );
            });
    };
    const handleDataBeforeSubmit = () => {
        let content = replyData;
        mentionedUsers.forEach((mention) => {
            content = content?.replaceAll(mention["attributes"].email, `@__${mention.id}`);
        });
        return content;
    };
    const repliesBody = () => (
        <>
            <RepliesHeader>
                <Title>Replies</Title>
                <Count>
                    ({objection?.objectionReplies?.length}){" "}
                    {objection?.objectionReplies?.length > 1 ? "replies" : "reply"}
                </Count>
            </RepliesHeader>
            <RepliesContent>
                {objection?.objectionReplies?.length > 0 ? (
                    objection?.objectionReplies?.map((item, index) => (
                        <RepliesContainer>
                            <Header>
                                <CreatorDetails>
                                    <CreatorIcon>
                                        <img
                                            src={userIcon}
                                            alt="userIcon"
                                        />
                                    </CreatorIcon>
                                    <CreatorInfo>
                                        <div className="name">{item?.creatorName}</div>
                                        <div className="email">{item?.creatorEmail}</div>
                                    </CreatorInfo>
                                </CreatorDetails>
                                <CreatedDate>
                                    <div className="label">Created On</div>
                                    <div className="createdAt">
                                        {new Date(item?.createdAt).toLocaleDateString("en-us", {
                                            weekday: "long",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}{" "}
                                    </div>
                                </CreatedDate>
                            </Header>
                            <Content>
                                <Item>
                                    <LabelStyle>Reply</LabelStyle>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: sanitize(item?.replay),
                                        }}
                                    />
                                </Item>
                            </Content>
                        </RepliesContainer>
                    ))
                ) : (
                    <NoReplies>there is no replies here </NoReplies>
                )}
            </RepliesContent>
        </>
    );
    return (
        <Objection>
            <ObjectionDetails>
                <Header>
                    <CreatorDetails>
                        <CreatorIcon>
                            <img
                                src={userIcon}
                                alt="userIcon"
                            />
                        </CreatorIcon>
                        <CreatorInfo>
                            <div className="name">{objection?.creatorName}</div>
                            <div className="email">
                                {objection?.creatorEmail}
                                <Tags
                                    Class="tags"
                                    label={objection?.objectionStatus}
                                />
                            </div>
                        </CreatorInfo>
                    </CreatorDetails>
                    <CreatedDate>
                        <div className="label">Created On</div>
                        <div className="createdAt">
                            {new Date(objection?.createdAt).toLocaleDateString("en-us", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })}{" "}
                        </div>
                    </CreatedDate>
                </Header>
                <Content>
                    <ObjectionSectionInfo>
                        <Item>
                            <LabelStyle>Section :</LabelStyle>
                            <p>{objection?.objectionSection}</p>
                        </Item>
                        <Item>
                            <LabelStyle>item :</LabelStyle>
                            <p>{objection?.objectionItem}</p>
                        </Item>
                    </ObjectionSectionInfo>
                    <Item>
                        <LabelStyle>comment :</LabelStyle>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: objection?.objectionComment,
                            }}
                        />
                    </Item>
                </Content>
            </ObjectionDetails>
            <ObjectionReplies>{repliesBody()}</ObjectionReplies>
            <RepliesContainer>
                <Header>
                    <CreatorDetails>
                        <CreatorIcon>
                            <img
                                src={userIcon}
                                alt="userIcon"
                            />
                        </CreatorIcon>
                        <CreatorInfo>
                            <div className="name">{userInfo?.userName?.replace(/['"]+/g, "")}</div>
                            <div className="email">
                                {userInfo?.userEmail?.replace(/['"]+/g, "")}
                            </div>
                        </CreatorInfo>
                    </CreatorDetails>
                </Header>
                <Content>
                    <Item>
                        <LabelStyle>Reply</LabelStyle>
                        <TextInputWithMentionedStyled>
                            <TextInputWithMentioned
                                handleOnChange={(value) => {
                                    setEditorState(value);
                                    setReplyData(value?.getCurrentContent().getPlainText("<br/>"));
                                }}
                                mentionedOptions={mentionedUsers}
                                editorState={editorState}
                            />
                        </TextInputWithMentionedStyled>
                    </Item>
                </Content>
                <Footer>
                    <Button
                        name="Reply"
                        type="submit"
                        onChange={handleReply}
                        btnStyle="primaryBtn"
                    />
                    {objection?.objectionStatus !== "resolved" && (
                        <Button
                            name="Solve"
                            onChange={handleSolve}
                            btnStyle="secondBtn"
                        />
                    )}
                </Footer>
            </RepliesContainer>
        </Objection>
    );
}
